import test from './components/test';
import { headerScroll, headerHamburger } from './components/header';
import {
  odometerSettings,
  dataIllustrationSettings,
} from './components/odometer';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    test();
    headerScroll();
    headerHamburger();
    odometerSettings();
    dataIllustrationSettings();
    // @ts-ignore
    gsap.registerPlugin(ScrollToPlugin);
    document.querySelectorAll('a[href*="#"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        // @ts-ignore
        const hash = link.getAttribute('href').split('#')[1];
        if (!hash) return;

        const target = document.getElementById(hash);
        if (!target) return;

        e.preventDefault();
        // @ts-ignore
        gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: target,
            offsetY: 80, // sticky header height
          },
          ease: 'none',
        });
      });
    });
    if (!window.location.hash) return;

    const target = document.querySelector(window.location.hash);
    if (!target) return;

    const headerOffset = 120;

    // Give ScrollTrigger a moment to calculate pins
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // @ts-ignore
        gsap.to(window, {
          scrollTo: {
            y: target,
            offsetY: headerOffset,
          },
          duration: 0.6,
          ease: 'none',
          // @ts-ignore
          onComplete: () => ScrollTrigger.refresh(),
        });
      });
    });
  },
  false,
);
